import { render, staticRenderFns } from "./ViolationControl.vue?vue&type=template&id=69b84c8e&scoped=true&"
import script from "./ViolationControl.vue?vue&type=script&lang=js&"
export * from "./ViolationControl.vue?vue&type=script&lang=js&"
import style0 from "./ViolationControl.vue?vue&type=style&index=0&id=69b84c8e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b84c8e",
  null
  
)

export default component.exports